<template>
  <div class="apply-form">
    <!-- 项目概览 -->
    <div class="info-card">
      <h3>{{ info.tendName }}</h3>
      <div class="info-grid">
        <div><label>标段编号</label><span>{{ info.prjNo }}</span></div>
        <div><label>保证金金额</label><span class="num">¥ {{ money }}</span></div>
        <div><label>开标时间</label><span>{{ info.tendStDate }}</span></div>
        <div><label>缴纳截止</label><span>{{ info.prjEndEarDate }}</span></div>
      </div>
    </div>

    <!-- 企业信息 -->
    <div class="info-card">
      <h3>企业信息</h3>
      <div class="info-grid">
        <div><label>企业名称</label><span>{{ coForm.coName }}</span></div>
        <div><label>法定代表人</label><span>{{ coForm.coLep }}</span></div>
        <div><label>统一信用代码</label><span>{{ coForm.coCode }}</span></div>
        <div><label>法人身份证</label><span>{{ coForm.coLepCode }}</span></div>
      </div>
    </div>

    <!-- 经办人表单 -->
    <div class="info-card">
      <h3>经办人信息</h3>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <div class="form-grid">
          <el-form-item label="经办人姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名" />
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="form.idCard" placeholder="请输入身份证号" />
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item label="邮箱" prop="eMail">
            <el-input v-model="form.eMail" placeholder="请输入邮箱" />
          </el-form-item>
          <el-form-item label="业务员" prop="busPeople">
            <el-select v-model="form.busPeople" placeholder="请选择业务员" style="width: 100%">
              <el-option
                v-for="b in buinessList"
                :key="b.no"
                :label="`${b.name} (${b.no})`"
                :value="b.no"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="验证码" prop="code" class="code-row">
            <el-input v-model="form.code" placeholder="请输入验证码" />
            <button class="code-btn" :disabled="!countshow" @click="getCode">
              {{ countshow ? '获取验证码' : `${count}s` }}
            </button>
          </el-form-item>
        </div>

        <el-form-item v-if="code === 'LYBH'" label="担保承诺书" prop="outUrl">
          <el-upload :action="action" :headers="headers" :limit="1" :on-success="onUpload" :file-list="bookList">
            <div v-if="!bookList.length" class="upload-trigger">
              <i class="el-icon-upload"></i><span>上传文件</span>
            </div>
          </el-upload>
          <a v-if="!bookList.length" class="template-link" :href="people.modelUrl || ''">
            <i class="el-icon-download"></i> 下载《委托担保承诺书》模板
          </a>
        </el-form-item>

        <el-form-item v-if="code === 'LYBH'" label="担保协议" prop="url">
          <el-upload :action="action" :headers="headers" :limit="1" :on-success="onUpload2" :file-list="fileList">
            <div v-if="!fileList.length" class="upload-trigger">
              <i class="el-icon-upload"></i><span>上传文件</span>
            </div>
          </el-upload>
          <a v-if="!fileList.length" class="template-link" :href="people.modelUrl || ''">
            <i class="el-icon-download"></i> 下载《委托担保服务协议》模板
          </a>
        </el-form-item>
      </el-form>
    </div>

    <div class="actions">
      <button class="g-btn g-btn-default" @click="$emit('back')">上一步</button>
      <button class="g-btn g-btn-primary" @click="next">下一步</button>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/lib/utils/baseUrl'
import { getBusMap, getCode } from '@/lib/api/project'

export default {
  name: 'ApplyForm',
  props: {
    info: { type: Object, default: () => ({}) },
    coForm: { type: Object, default: () => ({}) },
    code: { type: String, default: '' },
    productList: { type: Array, default: () => [] }
  },
  data () {
    return {
      action: baseUrl + '/buiness/coword/uploadFile',
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      form: {
        name: '', idCard: '', phone: '', eMail: '',
        code: '', busPeople: '', url: '', outUrl: ''
      },
      fileList: [],
      bookList: [],
      buinessList: [],
      timer: null,
      count: 60,
      countshow: true,
      rules: {
        name: [{ required: true, message: '请输入经办人姓名', trigger: 'blur' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证格式不正确' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确' }
        ],
        eMail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/, message: '邮箱格式不正确' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        busPeople: [{ required: true, message: '请选择业务员', trigger: 'change' }]
      }
    }
  },
  computed: {
    money () {
      return this.info.prjEarMoney ? Number(this.info.prjEarMoney).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-'
    }
  },
  created () {
    getBusMap().then((res) => {
      if (res.code === 200) this.buinessList = res.data
    })
  },
  beforeDestroy () { clearInterval(this.timer) },
  methods: {
    getCode () {
      if (!this.countshow) return
      if (!this.form.phone) return this.$message.warning('请先填写手机号')
      this.count = 60
      this.countshow = false
      this.timer = setInterval(() => {
        if (this.count > 0) this.count--
        else { this.countshow = true; clearInterval(this.timer); this.timer = null }
      }, 1000)
      getCode({ phone: this.form.phone }).then(() => this.$message.success('验证码已发送'))
    },
    onUpload (res, file) { this.bookList = [{ name: file.name, url: res.url }] },
    onUpload2 (res, file) { this.fileList = [{ name: file.name, url: res.url }] },
    next () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.$emit('next', this.form)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.apply-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-card {
  background: #fff;
  border-radius: @radius-lg;
  padding: 24px 28px;
  box-shadow: @shadow-sm;

  h3 {
    margin: 0 0 20px;
    font-size: 17px;
    color: @text-strong;
    font-weight: 700;
    padding-left: 12px;
    border-left: 3px solid @primary;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px 32px;

  > div {
    display: flex;
    font-size: 14px;

    label {
      color: @text-muted;
      width: 100px;
      flex-shrink: 0;
    }
    span {
      color: @text-base;
      .num { color: @danger; font-weight: 700; }
    }
  }
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 24px;
}

.code-row {
  ::v-deep .el-form-item__content {
    display: flex;
    gap: 12px;
  }
  .code-btn {
    height: 36px;
    padding: 0 16px;
    border-radius: @radius-sm;
    border: 1px solid @primary;
    color: @primary;
    background: @primary-soft;
    cursor: pointer;
    white-space: nowrap;

    &:disabled {
      background: @bg-soft;
      color: @text-disabled;
      border-color: @border-base;
    }
  }
}

.upload-trigger {
  width: 220px;
  height: 80px;
  border: 1px dashed @border-base;
  border-radius: @radius-md;
  background: @bg-soft;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: @text-muted;
  cursor: pointer;
  gap: 6px;
  font-size: 13px;
}

.template-link {
  display: inline-block;
  margin-top: 8px;
  font-size: 13px;
  color: @primary;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}
</style>
